import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/react-hooks';

import { MyTeamMenu } from './MyTeamMenu';
import { MenuButton } from './components/MenuButton';
import {
  authHome,
  authDashboard,
  authPlansAndPricing,
} from '../../config/linkInfo';

import authenticatedQuery from '../authenticated.graphql';

const NavBarAuth = ({ user: { session } }) => {
  const { loading, error, data } = useQuery(authenticatedQuery, {});
  if (loading) return <div className="sm-header__nav-auth" />;
  if (error) return <div className="sm-header__nav-auth" />;
  if (!data || !data.user) return <div className="sm-header__nav--auth" />;

  const { user } = data;
  const teamMembership = user.teamMembership || {};
  const canSeeTeamTab = teamMembership.isAdmin || teamMembership.isEnterprise;

  return (
    <div className="sm-header__nav--auth">
      <MenuButton {...authDashboard()} />
      <MenuButton {...authHome()} />
      {canSeeTeamTab ? <MyTeamMenu user={user} session={session} /> : null}
      <MenuButton {...authPlansAndPricing()} />
    </div>
  );
};

NavBarAuth.propTypes = {
  user: PropTypes.shape({
    session: PropTypes.shape({
      isAdminImpersonation: PropTypes.bool,
    }),
  }).isRequired,
};

export default NavBarAuth;
